<template>
  <div class="c-scrubber">
    <div class="c-scrubber__inner" :style="style"></div>
  </div>
</template>

<script>
import youtubeHelper from "@/lib/youtube-helper.js";
export default {
  props: {
    duration: {
      type: Number,
      default: 3000,
    },
    currentTime: {
      type: Object,
      default: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    },
    totalTime: {
      type: Object,
      default: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    },
  },
  computed: {
    style: function () {
      let left = this.timeToPercentage(this.currentTime, this.totalTime);
      let style = {
        left: left + "%",
      };
      return style;
    },
  },
  methods: {
    timeToPercentage: function (currentTime, totalTime) {
      let currentSeconds = youtubeHelper.timeToSeconds(currentTime);
      let totalSeconds = youtubeHelper.timeToSeconds(totalTime);
      let pos = youtubeHelper.scaleValue(
        currentSeconds,
        [0, totalSeconds],
        [0, 100]
      );
      console.log(pos);
      return pos;
    },
  },
};
</script>

<style lang="scss">
.c-scrubber {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: var(--s3);
  overflow: hidden;

  &__inner {
    position: absolute;
    top: 0;
    width: 8px;
    height: 100%;
    background-color: var(--s2);
  }
}
</style>